var React = require('react');

function TechStack (props) {
    return React.createElement("svg",props,[React.createElement("ellipse",{"cx":"17.0568","cy":"17.0204","rx":"17.0568","ry":"17.0204","fill":"#55DF20","key":0}),React.createElement("path",{"d":"M37.5 9L14 20.75L37.5 32.5L61 20.75L37.5 9Z","stroke":"white","strokeWidth":"3","strokeLinecap":"square","key":1}),React.createElement("path",{"d":"M14 44.25L37.5 56L61 44.25","stroke":"white","strokeWidth":"3","strokeLinecap":"square","key":2}),React.createElement("path",{"d":"M14 32.5L37.5 44.25L61 32.5","stroke":"white","strokeWidth":"3","strokeLinecap":"square","key":3})]);
}

TechStack.defaultProps = {"width":"65","height":"58","viewBox":"0 0 65 58","fill":"none"};

module.exports = TechStack;

TechStack.default = TechStack;
